
import gql from 'graphql-tag'
import userFavProductShortTermSaving from '@/apollo/queries/user/userFavProductShortTermSaving'
import productPromotionFragment from '~/apollo/fragments/productPromotionFragment'
import shortTermsSavTooltips from '~/apollo/queries/product/tooltips/shortTermsSavTooltips'
import productPromotionMixins from '~/mixins/productPromotionMixins.js';
import productInsuranceNameMixins from '~/mixins/productInsuranceNameMixins';

export default {
  name: "ProductShortTermSavingCardAdapter",
  mixins: [productPromotionMixins, productInsuranceNameMixins],
  data: () => ({
    product: Object,
    productLoading: 0,
    currentLink: "",
  }),
  props: {
    productId: String,
    params: String,
    favProductId: String,
  },
  apollo: {
    product: {
      prefetch: true,
      loadingKey: "productLoading",
      query: gql`${userFavProductShortTermSaving} ${productPromotionFragment}`,
      variables() {
        const returnObj = {};

        returnObj.id = this.productId;
        returnObj.locale = this.$normalizeLocale(this.$i18n.locale);
        returnObj.year = parseInt(this.simpleParams.year?this.simpleParams.year:1);

        return returnObj;
      },
      update(data) {
        return data?.shortTermSavPlanScenarios?.data;
      },
      result({ data }) {
        // console.debug(JSON.stringify(data));
      },
    },
    tooltips: {
      query: shortTermsSavTooltips,
      prefetch: true,
      variables() {
        return { currentlocale: this.$normalizeLocale(this.$i18n.locale) };
      },
      update(data) {
        return this.$normalizeStrapi(data.infoTooltip.data).ShortTermSav;
      },
    },
  },
  computed: {
    simpleItem() {
      if (!this.productLoading) {
        if (this.product) {
          return this.product.map((item) => {
            let promotions = null;
            let promotion = null;
            let promotion_last_call = null;

            const planName = item.attributes.short_term_sav_plan.data.attributes.short_term_sav_plan_translations.data[0].attributes.name;
            const insurer = item.attributes.short_term_sav_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.insurance_company_translations.data[0].attributes.name;
            const link = this.currentLink;
            let decoderCTALink = this.$generateWhatsappCTALink(this.$t('products.shortSavings.st_categoryName'), insurer, planName, { page: this.$route.name?.split('__')[0], link: link });
            let decoderCTAText = '';

            let hide = Boolean;
            hide = false;

            // check scenario level promo first , then plan level promotion 
            if (item.attributes.product_promotions.data?.length > 0) {
              promotions = item.attributes.product_promotions.data;
            }
            if (item.attributes.short_term_sav_plan.data.attributes.product_promotions.data?.length > 0) {
              promotions = item.attributes.short_term_sav_plan.data.attributes.product_promotions.data;
            }
            
            if(promotions != null) {
              promotion = this.checkPromotionValid(promotions);
              promotion_last_call = this.checkPromotionLastCall(promotion);

              if (!promotion) {
                promotion = null;
              }
              else if (promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink) {
                decoderCTALink = promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink;
                decoderCTAText = this.$t('products.product_website');

                const translation = promotion.attributes.product_promotion_translations?.data[0];
                hide = translation.attributes?.HideBanner;
              }
            }


            const maturity = item.attributes.maturity;
            const year = this.simpleParams.year?this.simpleParams.year:1;

            const filteredTranslations = this.getFilteredTranslations(item.attributes.short_term_sav_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
            .insurance_company_translations.data[0].attributes.localizations.data);

            return {
              scenario_code: item.attributes.scenario_code,
              payment_term: item.attributes.premium_term,
              rating: item.attributes.rating,
              gbey: parseInt(item.attributes.gbey),
              currency_code: item.attributes.currency.data.attributes.code,
              currency: item.attributes.currency.data.attributes.currency_translations.data[0].attributes,
              min_total_premium: item.attributes.min_total_premium,
              maturity,

              // // plan
              plan_name: item.attributes.short_term_sav_plan.data.attributes.short_term_sav_plan_translations.data[0].attributes.name,
              online_purchase: item.attributes.short_term_sav_plan.data.attributes.online_purchase,

              // // insurer
              insurer_name_first: item.attributes.short_term_sav_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.insurance_company_translations.data[0].attributes.name,
              insurer_name_second: filteredTranslations[0].attributes.name,
              insurer_logo: item.attributes.short_term_sav_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.logo,
              insurer_code: item.attributes.short_term_sav_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.code,

              // // financial details
              financial_result_year1: item.attributes.short_term_sav_fins.data.filter(item => item.attributes.year === 1),
              financial_result: item.attributes.short_term_sav_fins.data.filter(item => item.attributes.year === parseInt(year)),
              product_promotion: promotion,
              promotion_last_call: promotion_last_call,

              decoder_cta_link: decoderCTALink,
              decoder_cta_text: decoderCTAText,
              scenarioID: item.id,

              hide,
            };
          })[0];
        }
      }
      return null;
    },

    displayProduct() {
      if (this.simpleItem) {
        const item = this.simpleItem;
        return {
          favProductId: this.favProductId,
          scenarioId: item.scenarioID,
          id: item.scenario_code,
          productType: "short-term-savings",
          showFiveStarBadge: this.$formatShowFiveStarBadge(item.overall_star),
          showTrending: false,
          productLink: `/products/short-term-savings/${item.scenario_code}` + '?year='+this.simpleParams.year,
          productName: item.plan_name,
          insuranceCompany: {
            name: item.insurer_name_first + ' | ' + item.insurer_name_second,
            code: item.insurer_code,
            logoSrc: item.insurer_logo?.data?.attributes.url,
            logoAlt: item.insurer_name_first,
          },
          userRating: {
            score: item.overall_star,
            numberOfRatedUser: '0',
          },
          tenlifeScore: {
            score: parseFloat(this.getScore(item)),
            description: this.$t('products.shortSavings.st_shortTermSavingsScore'),
            toolTipHtml: this.getTooltipContentByKey('st_shortTermSavingsScore'),
          },
          features: [
            {
              text: this.getCurrency(item.currency),
              type: 'default',
            },
            {
              text: (parseInt(item.payment_term) === 1) ? this.$t('products.prepaid') : item.payment_term + this.$t('products.shortSavings.st_yearpayment'),
              type: 'default',
            },
            {
              text: item.maturity + this.$t('products.shortSavings.st_yearmaturity'),
              type: 'default',
            },

          ],
          keyItems: [
            {
              value: this.$formatPercentageDP(item.financial_result[0].attributes.guarantee_irr_surrender, 2),
              key: this.getReturnRatioLabel(item.maturity, this.$t('products.shortSavings.st_targetPeriodGuaranteedIRR')),
              topSubText: '',
              toolTipHtml: this.getTargetPeriodGuaranteedIRRTooltip(),
              symbolValue: '',
              originalValue: '',
            },
            {
              // value: (item.gbey > 1)? item.gbey + " " + this.$t('products.yearsUnit') : item.gbey + " " + this.$t('products.yearUnit'),
              value: (item.gbey > 0) ? item.gbey : '<span style="white-space: nowrap;">' + this.$t('products.shortSavings.st_gbey_immediate') + '</span>',
              key: this.$t('products.shortSavings.st_guaranteedBreakeven'),
              topSubText: '',
              toolTipHtml: '',
              symbolValue: '',
              originalValue: '',
            },
            {
              value: this.$formatPrice(item.min_total_premium),
              key: this.$t('products.shortSavings.st_minimumTotalPremium'),
              topSubText: item.currency_code,
              toolTipHtml: '',
              symbolValue: '',
              originalValue: '',
            },
          ],
          compactKeyItems: [
            {
              value: this.$formatPrice(item.min_total_premium),
              key: this.$t('products.shortSavings.st_minimumTotalPremium'),
              topSubText: item.currency_code,
              toolTipHtml: '',
              symbolValue: '',
              originalValue: '',
            },
            {
              value: this.$formatPercentageDP(item.financial_result[0].attributes.guarantee_return_ratio, 1),
              key: this.getReturnRatioLabel(this.simpleParams?.year, this.$t('products.shortSavings.st_guaranteedReturnRatio')),
              topSubText: '',
              toolTipHtml: this.getTooltipContentByKey('st_' + item.maturity + 'thyearGuaranteedReturnRatio'),
              symbolValue: '',
              originalValue: '',
            },

          ],
          promotion: {
            category: item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.PromotionCategory,
            title: item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.PromotionTitle,
            ctaButtonLink: item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonLink,
            ctaButtonText: item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonText,
            promotionId: item.product_promotion?.id,
            scenarioId: item.scenarioID,
            hide: item.hide,
            lastCall: item.promotion_last_call
          },
          mainButtonCTA: {
            text: item.decoder_cta_text,
            link: item.decoder_cta_link,
          },
          price: {
            originalPrice: '',
            discountPrice: this.$formatPercentageDP(item.financial_result[0].attributes.guarantee_return_ratio, 1),
            prefix: '',
            postfix: '',
            subText: this.getReturnRatioLabel(item.maturity, this.$t('products.shortSavings.st_guaranteedReturnRatio')),
            toolTipHtml: this.getTooltipContentByKey('st_' + item.maturity + 'thyearGuaranteedReturnRatio'),
          },
        }
      }
      return null
    },

    simpleParams() {
      let vars = Array;
      vars = [];
      const hash = this.params.split('&');

      for (let i = 0; i < hash.length; i++) {
        const params = hash[i].split("=");
        vars[params[0]] = params[1];
      }

      return vars;
    }
  },
  watch: {
    product() {
      if (this.product.length) {
        this.$emit("product-load", 'STSav');
      } else {
        try {
          throw new Error("*** Product not found ***");
        } catch (e) {
          console.error(e.name + ": " + e.message);
          this.$sentry.captureException(e);
        }
      }
    },
  },
  mounted() {
    this.currentLink = window.location.href;
  },
  updated() {
    if (this.simpleItem) {
      this.$emit("productTitle", { id: this.favProductId, companyName: this.simpleItem.insurer_name_first, title: this.simpleItem.plan_name });
    }
  },
  methods: {
    getCurrency(curr) {
      if (this.$normalizeLocale(this.$i18n.locale) === "zh-Hant-HK") {
        return curr.text;
      }
      else {
        return curr.localizations.data[0].attributes.text;
      }
    },

    getScore(product) {
      return this.$formatScore(
        product.financial_result[0].attributes.rating
          ? product.financial_result[0].attributes.rating
          : 0,
        2
      );
    },

    getReturnRatioLabel(index, label) {
      if (this.$normalizeLocale(this.$i18n.locale) === "en") {
        return label.replace("$num", this.$ordinalSuffix(index));
      }
      else if (this.$normalizeLocale(this.$i18n.locale) === "zh-Hant-HK") {
        return label.replace("$num", index);
      }
    },

    getTooltipContentByKey(mKey) {
      return this.tooltips?.ToolTips?.find(({ Key }) => Key === mKey)?.ToolTipContent ?? '';
    },

    getTargetPeriodGuaranteedIRRTooltip() {
      const tooltip = this.getTooltipContentByKey('st_targetPeriodGuaranteedIRR');
      const maturityValue = this.simpleItem.maturity.toString();
      const processedMaturityYearValue =
        this.$normalizeLocale(this.$i18n.locale) === 'zh-Hant-HK' ? maturityValue : this.$ordinalSuffix(parseInt(maturityValue));
      return tooltip?.replace('{replace_year}', processedMaturityYearValue);
    },

    unfavourite() {
      this.product = null;
    },
  },
}
